"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = parsePrompt;
function parsePrompt(prompt) {
    const params = prompt.split(".");
    const args = {};
    for (let param of params) {
        const [key, value] = param.split(":").map(part => part.trim());
        args[key] = value;
    }
    return args;
}
